import HeroSection from "../components/about/HeroSection";
import Business from "../components/about/Business";
import Values from "../components/about/Values";
import Team from "../components/about/Team";
import Footer from "../components/shared/Footer";

function About() {
  return (
    <div className="flex flex-col">
      <HeroSection />
      <Business />
      {/* <Mission /> */}
      <Values />
      <Team />
      {/* <Members/> */}
      <Footer />
    </div>
  );
}

export default About;
